import { useEffect } from 'react';

/** Warn on tab close/refresh when `when` is true (browser native dialog). */
export function useBeforeUnload(when) {
  useEffect(() => {
    if (!when) return undefined;
    const onBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [when]);
}
